import React, { Component } from "react";
import { MdExpandMore } from "react-icons/md";
import Moment from "react-moment";

class ListMovements extends Component {
  render() {
    const { movements, senders, selectedContent } = this.props;
    return (
      <React.Fragment>
        <div className="container">
          <div className="movement-content">
            <div
              className="card-panel white lighten-5 z-depth-1"
              style={{
                width: "100%",
                margin: "auto",
                height: "auto",
                display: "block",
                position: "relative",
                boxShadow:
                  "0 2px 5px rgba(0, 0, 0, 0.12), 0 2px 5px rgba(0, 0, 0, 0.24)",
                fontSize: "1.1rem",
                marginTop: "205px"
              }}
            >
              {selectedContent.length > 0 ? (
                selectedContent.map((movement, i) => (
                  <React.Fragment key={i}>
                    <div
                      className="accordion md-accordion accordion-blocks"
                      id="accordionEx78"
                      role="tablist"
                      aria-multiselectable="true"
                      style={{
                        alignContent: "left",
                        backgroundColor: "white",
                        boxShadow:
                          "0 2px 5px rgba(0, 0, 0, 0.12), 0 2px 5px rgba(0, 0, 0, 0.24)",
                        display: "block",
                        margin: "auto"
                      }}
                    >
                      <div className="card white" id={"card" + i}>
                        <div
                          className="card-header"
                          role="tab"
                          id={"headingUnfiled" + i}
                          style={
                            movement.status === "ativa"
                              ? {
                                  backgroundColor: "#357ae8"
                                }
                              : {
                                  backgroundColor: "gray"
                                }
                          }
                        >
                          <a
                            data-toggle="collapse"
                            data-parent={"#card" + i}
                            href={"#collapseUnfiled" + i}
                            aria-expanded="true"
                            aria-controls="collapseUnfiled"
                          >
                            <h5 className="mt-4 mb-0">
                              <span style={{ color: "white" }}>
                                Movimentação
                                <p className="left" style={{ color: "white" }}>
                                  ID: {movement.id_movimentacao}
                                </p>
                                <p className="right" style={{ color: "white" }}>
                                  <MdExpandMore />
                                </p>
                              </span>
                            </h5>
                          </a>
                        </div>
                        <div
                          id={"collapseUnfiled" + i}
                          className="collapse show"
                          role="tabpanel"
                          aria-labelledby={"headingUnfiled" + i}
                          data-parent={"#card" + i}
                        >
                          <div className="card-body">
                            <React.Fragment>
                              <div
                                className="row justify-content-center"
                                style={{
                                  display: "block",
                                  margin: "auto",
                                  width: "100%"
                                }}
                              >
                                <div className="col s12">
                                  <table className="table table-adapt-query table-sm table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">ID Malote</th>
                                        <th scope="col">ID Item</th>
                                        <th scope="col">Remetente</th>
                                        <th scope="col">Destinatário</th>
                                        <th scope="col">Data de Criação</th>
                                        <th scope="col">Horário</th>
                                        <th scope="col">Data de Modificação</th>
                                        <th scope="col">Horário</th>
                                        <th scope="col">
                                          <i>Status</i>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td
                                          style={{
                                            fontWeight: "bolder"
                                          }}
                                        >
                                          {movement.id_transacao}
                                        </td>
                                        <td
                                          style={{
                                            fontWeight: "bolder"
                                          }}
                                        >
                                          {movement.id_item}
                                        </td>
                                        {senders.length > 0 &&
                                          senders
                                            .filter(
                                              sender =>
                                                sender.id ===
                                                movement.id_remetente
                                            )
                                            .map((sender, l) => (
                                              <td key={l}>
                                                {sender.usuario
                                                  .toUpperCase()
                                                  .replace(".", " ")}
                                              </td>
                                            ))}
                                        {senders.length > 0 &&
                                          senders
                                            .filter(
                                              recipient =>
                                                recipient.id ===
                                                movement.id_destinatario
                                            )
                                            .map(
                                              (recipient, l) =>
                                                l === 0 && (
                                                  <td key={l}>
                                                    {recipient.usuario
                                                      .toUpperCase()
                                                      .replace(".", " ")}
                                                  </td>
                                                )
                                            )}
                                        <td>
                                          <Moment format="DD/MM/YYYY">
                                            {movement.created_at}
                                          </Moment>
                                        </td>
                                        <td>
                                          <Moment
                                            add={{ hours: 3 }}
                                            format="HH:mm:ss"
                                          >
                                            {movement.created_at}
                                          </Moment>
                                        </td>
                                        <td>
                                          <Moment format="DD/MM/YYYY">
                                            {movement.updated_at}
                                          </Moment>
                                        </td>
                                        <td>
                                          <Moment
                                            add={{ hours: 3 }}
                                            format="HH:mm:ss"
                                          >
                                            {movement.updated_at}
                                          </Moment>
                                        </td>
                                        <td>
                                          <i
                                            style={
                                              movement.status === "ativa"
                                                ? {
                                                    color: "#357ae8"
                                                  }
                                                : {
                                                    color: "red"
                                                  }
                                            }
                                          >
                                            {movement.status.toUpperCase()}
                                          </i>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </React.Fragment>
                          </div>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                ))
              ) : selectedContent && movements.length > 0 ? (
                movements.map((movement, i) => (
                  <React.Fragment key={i}>
                    <div
                      className="accordion md-accordion accordion-blocks"
                      id="accordionEx78"
                      role="tablist"
                      aria-multiselectable="true"
                      style={{
                        alignContent: "left",
                        backgroundColor: "white",
                        boxShadow:
                          "0 2px 5px rgba(0, 0, 0, 0.12), 0 2px 5px rgba(0, 0, 0, 0.24)",
                        display: "block",
                        margin: "auto"
                      }}
                    >
                      <div className="card white" id={"card" + i}>
                        <div
                          className="card-header"
                          role="tab"
                          id={"headingUnfiled" + i}
                          style={
                            movement.status === "ativa"
                              ? {
                                  backgroundColor: "#357ae8"
                                }
                              : {
                                  backgroundColor: "gray"
                                }
                          }
                        >
                          <a
                            data-toggle="collapse"
                            data-parent={"#card" + i}
                            href={"#collapseUnfiled" + i}
                            aria-expanded="true"
                            aria-controls="collapseUnfiled"
                          >
                            <h5 className="mt-4 mb-0">
                              <span style={{ color: "white" }}>
                                Movimentação
                                <p className="left" style={{ color: "white" }}>
                                  ID: {movement.id_movimentacao}
                                </p>
                                <p className="right" style={{ color: "white" }}>
                                  <MdExpandMore />
                                </p>
                              </span>
                            </h5>
                          </a>
                        </div>
                        <div
                          id={"collapseUnfiled" + i}
                          className="collapse show"
                          role="tabpanel"
                          aria-labelledby={"headingUnfiled" + i}
                          data-parent={"#card" + i}
                        >
                          <div className="card-body">
                            <React.Fragment>
                              <div
                                className="row justify-content-center"
                                style={{
                                  display: "block",
                                  margin: "auto",
                                  width: "100%"
                                }}
                              >
                                <div className="col s12">
                                  <table className="table table-adapt-query table-sm table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">ID Malote</th>
                                        <th scope="col">ID Item</th>
                                        <th scope="col">Remetente</th>
                                        <th scope="col">Destinatário</th>
                                        <th scope="col">Data de Criação</th>
                                        <th scope="col">Horário</th>
                                        <th scope="col">Data de Modificação</th>
                                        <th scope="col">Horário</th>
                                        <th scope="col">
                                          <i>Status</i>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td
                                          style={{
                                            fontWeight: "bolder"
                                          }}
                                        >
                                          {movement.id_transacao}
                                        </td>
                                        <td
                                          style={{
                                            fontWeight: "bolder"
                                          }}
                                        >
                                          {movement.id_item}
                                        </td>
                                        {senders.length > 0 &&
                                          senders
                                            .filter(
                                              sender =>
                                                sender.id ===
                                                movement.id_remetente
                                            )
                                            .map((sender, l) => (
                                              <td key={l}>
                                                {sender.usuario
                                                  .toUpperCase()
                                                  .replace(".", " ")}
                                              </td>
                                            ))}
                                        {senders.length > 0 &&
                                          senders
                                            .filter(
                                              recipient =>
                                                recipient.id ===
                                                movement.id_destinatario
                                            )
                                            .map(
                                              (recipient, l) =>
                                                l === 0 && (
                                                  <td key={l}>
                                                    {recipient.usuario
                                                      .toUpperCase()
                                                      .replace(".", " ")}
                                                  </td>
                                                )
                                            )}
                                        <td>
                                          <Moment format="DD/MM/YYYY">
                                            {movement.created_at}
                                          </Moment>
                                        </td>
                                        <td>
                                          <Moment
                                            add={{ hours: 3 }}
                                            format="HH:mm:ss"
                                          >
                                            {movement.created_at}
                                          </Moment>
                                        </td>
                                        <td>
                                          <Moment format="DD/MM/YYYY">
                                            {movement.updated_at}
                                          </Moment>
                                        </td>
                                        <td>
                                          <Moment
                                            add={{ hours: 3 }}
                                            format="HH:mm:ss"
                                          >
                                            {movement.updated_at}
                                          </Moment>
                                        </td>
                                        <td>
                                          <i
                                            style={
                                              movement.status === "ativa"
                                                ? {
                                                    color: "#357ae8"
                                                  }
                                                : {
                                                    color: "red"
                                                  }
                                            }
                                          >
                                            {movement.status.toUpperCase()}
                                          </i>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </React.Fragment>
                          </div>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                ))
              ) : (
                <p style={{ paddingTop: "25px" }}>
                  Nenhum registro encontrado.
                </p>
              )}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ListMovements;
